import Immutable from 'immutable';

const AuthenticationType: {
  [key: string]: 'usr-pw' | 'okta' | 'azure' | 's2'
} = {
  USER_PASSWORD: 'usr-pw',
  OKTA_LINK: 'okta',
  AZURE : 'azure',
  S2: 's2'
};

const Content: {
  type: 'usr-pw' | 'okta' | 'azure' | 's2',
  name: string,
  link: string | null
} = {
  type: AuthenticationType.USER_PASSWORD,
  name: 'AAServer',
  link: null
};

class AuthenticationMethod extends Immutable.Record(Content) {
  static get Type () {
    return AuthenticationType;
  }
}

export default AuthenticationMethod;
